module.exports = __webpack_public_path__ + "img/icon_bucket.3da8c75f.svg";